// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___LalKB","main":"style-module__main___ghUN3"};